import { Modal, Form, Select, message, Input, FormInstance } from "antd";
import axios from "../../services/axiosInstance";
import { INVITE_MEMBER } from "../../services/apiEndPoints";

const MemberInviteComponent = (inviteForm: FormInstance<any>, isInviteModalOpen: boolean | undefined, setIsInviteModalOpen: (arg0: boolean) => void, fetchMembers: { (): Promise<void>; (): any; }) => {

    const handleInviteMember = async () => {
        try {
            const values = await inviteForm.validateFields();

            const data = {
                ...values,
                phoneNumber: '',
                loginType: 'email' as const,
            }

            const response = await axios.post(INVITE_MEMBER, data)
            console.log(response.data)

            message.success("Invitation sent successfully");
            inviteForm.resetFields();
            await fetchMembers()
            setIsInviteModalOpen(false);
        } catch (error) {
            // validation errors handled by form
        }
    };


    return (
        <Modal
            title="Invite Member"
            open={isInviteModalOpen}
            onCancel={() => setIsInviteModalOpen(false)}
            onOk={() => handleInviteMember()}
            okText="Send Invite"
        >
            <Form
                form={inviteForm}
                layout="vertical"
                requiredMark={false}
            >
                <Form.Item
                    label="Member Name"
                    name="memberName"
                    rules={[{ required: true, message: "Please enter member name" }]}
                >
                    <Input placeholder="John Doe" />
                </Form.Item>

                <Form.Item
                    label="Member Email"
                    name="memberEmail"
                    rules={[
                        { required: true, message: "Please enter email address" },
                        { type: "email", message: "Please enter a valid email" },
                    ]}
                >
                    <Input placeholder="john@example.com" />
                </Form.Item>

                <Form.Item
                    label="Role"
                    name="role"
                    rules={[{ required: true, message: "Please select a role" }]}
                >
                    <Select placeholder="Select role">
                        <Select.Option value="admin">Admin</Select.Option>
                        <Select.Option value="user">User</Select.Option>
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default MemberInviteComponent;
